import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_myPersonalMission = () =>
	queryOptions({
		queryKey: ["personal-mission"] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.personalMission.personalMissionControllerGet({
					signal: context.signal,
				}),
			),
	});
